import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckBox } from '@drdropin-tech/theseus';
import { useModal } from '../providers/ModalProvider';
export default function TermsOfService(props) {
    const t = props.i18nFunction;
    const { openModal } = useModal();
    function toggleModal() {
        openModal({
            content: {
                title: t('terms.modal_title'),
                iframeSrc: t('terms.modal_content'),
            },
        });
    }
    return (_jsxs("div", { className: "rounded-lg bg-black/20 px-4 py-6", children: [_jsx("p", { className: "text-sm", children: t('terms.accept_text') }), _jsx("br", {}), _jsx("u", { onClick: toggleModal, children: t('terms.terms') }), _jsx(CheckBox, { label: t('terms.accept'), checked: props.checked, onChange: () => props.onChange(!props.checked), theme: "general", classname: "border-white" })] }));
}
